var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVectorSeckill = function SvgVectorSeckill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 59,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F7B",
    d: "M.349 33.84 9.475.735A1 1 0 0 1 10.439 0h21.484a1 1 0 0 1 .892 1.451l-9.501 18.8a1 1 0 0 0 .892 1.451h13.616a1 1 0 0 1 .759 1.652L8.286 58.615c-.331.386-.96.088-.871-.413l3.877-21.921a1 1 0 0 0-.984-1.175H1.313a1 1 0 0 1-.964-1.265"
  })));
};
export default SvgVectorSeckill;